import React, { Component } from 'react';
import axios from 'axios';
import { NavLink, Navigate } from 'react-router-dom';
import {Button,Dialog,DialogTitle,DialogContent,DialogActions, Typography,Box,TablePagination, TextField,Card,CardContent,CardActions,Divider} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Serverurl from './Apiurl';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Fab from '@mui/material/Fab';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import editIconImg from './images/edit.png'; 
import deleteIconImg from './images/delete.png';

class Productlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],totalItems: 0,page: 0,rowsPerPage: 5,
      itemsPerPageOptions: [5, 10, 25, 50],logredirect: false,
      pagename: '',searchName: '',
    };
  }

  componentWillMount() {
	  if(localStorage.getItem("GBuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Businesslogin'
          })
		  }
    this.fetchProducts();
  }

  handleSearchChange = (e) => {
    this.setState({ searchName: e.target.value });
  };

  fetchProducts = () => {
	  const bu_id = localStorage.getItem("GBuserid");
    axios.get(Serverurl +"ajaxproduct.php?action=getall&StartIndex=" + this.state.page +"&PageSize=" +
    this.state.rowsPerPage +"&pr_name=" +this.state.searchName+ "&pr_bu_id=" + bu_id  )
      .then((res) => {
        const totalItems = parseInt(res.data[0]?.total || 0);
        this.setState({ products: res.data, totalItems });
      });
  };

  onPageChange = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchProducts);
  };

  onRowsPerPageChange = (event) => {
    this.setState(
      { rowsPerPage: parseInt(event.target.value, 10), page: 0 },
      this.fetchProducts
    );
  };

  searchProducts = () => {
    this.setState({ page: 0 }, this.fetchProducts);
  };

   handleDelete = (pr_id) => {
    confirmAlert({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this Product?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
	 const formData = new FormData();
    formData.append('action', 'delete');
    formData.append('pr_id', pr_id);
    formData.append('userid', localStorage.getItem("GBuserid"));

    axios.post(Serverurl + "ajaxproduct.php", formData).then(() => {
      this.fetchProducts();
    });
          }
        },
        { label: "No" },
      ],
    });
  };

  
  render() {
	
    if (this.state.logredirect) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
      <div className="formdisplay">
        
          <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
    marginBottom: "10px",
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
    }}
  >
       <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>

    <Typography variant="h4">
      Products
    </Typography>
  </Box>
</Box>

       
       <Box sx={{ display: 'flex', flexDirection: 'column', mb: 3 }}>
		   {/* <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: '500' }}>
    Search by Product Name
		   </Typography>*/}

  <TextField 
    variant="outlined" 
    size="small" 
    placeholder="Enter Product Name..."
    value={this.state.searchName} 
    onChange={this.handleSearchChange} 
    onKeyDown={(e) => {
      if (e.key === 'Enter') {
        this.searchProducts();
      }
    }}
	
	sx={{
 
      borderRadius: '50px',
      '& .MuiOutlinedInput-root': {
        borderRadius: '50px',
		border: '0.5px solid #c0c0c0',
		padding: '3px 0px !important',
        paddingRight: '4px',
        '& fieldset': {
          borderColor: '#e2e8f0',
        },
        '&:hover fieldset': {
          borderColor: '#cbd5e1 !important',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#11408f !important',
        },
      },
      '& .MuiOutlinedInput-input': {
        paddingLeft: '20px !important',
        fontSize: '14px',
      },
    }}
    fullWidth
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton onClick={this.searchProducts}
sx={{
              backgroundColor: '#11408f',
              color: '#ffffff',
			  width: '56px',
			  marginRight: '0px',
              padding: '11px',
              '&:hover': {
                backgroundColor: '#0d3476',
              },
            }}
			edge="end" aria-label="search">
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
</Box>



        
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {this.state.products.length > 0 ? (
            this.state.products.map((item) => (
              <li key={item.pr_id} style={{ marginBottom: 20 }}>
                <Card elevation={3}>
                    <div className="cardcontent">
				  <CardContent>
                 
                    <Typography variant="h6">{item.pr_name}</Typography>

                    
                    <Typography variant="subtitle1" color="primary" sx={{ mb: 1 }}>
                      ₹ {item.pr_price}
                    </Typography>

                  
                    
                    <Typography variant="body2">
                      <strong>GST:</strong> {item.pr_gst}% &nbsp; | &nbsp;
                      <strong>HSN:</strong> {item.pr_hsncode}
                    </Typography>

                   
                  
                  </CardContent>

                 </div>
				 <div className="cardactions">
                  <CardActions sx={{ justifyContent: 'flex-end' }}>
                    <a href={'/Addproduct?pid='+item.pr_id}
                      
                    >
                     <img
        src={editIconImg}
        alt="Edit"
        style={{ width: '28px' }}
      />
                      
                    </a>

                    <Button 
					className="frmthirdbtn"
                     onClick={() => this.handleDelete(item.pr_id)}
   
                    >
                       <img
        src={deleteIconImg}
        alt="Delete"
        style={{ width: '28px' }}
      />
                    </Button>
                  </CardActions>
				    </div>
                </Card>
              </li>
            ))
          ) : (
            <Typography align="center">No products found</Typography>
          )}
        </ul>

        {this.state.totalItems > 0 && (
        <TablePagination
  component="div"
  count={this.state.totalItems}
  page={this.state.page}
  onPageChange={this.onPageChange}
  rowsPerPage={this.state.rowsPerPage}
  onRowsPerPageChange={this.onRowsPerPageChange}
  rowsPerPageOptions={this.state.itemsPerPageOptions}
/>
)}
{/* Floating Add Button */}
<NavLink to="/Addproduct" style={{ textDecoration: 'none' }}>
  <Fab
    aria-label="add"
    sx={{
      position: 'fixed',
      bottom: 30,
      right: 30,
      zIndex: 1000,
      backgroundColor: '#11408f',   
      color: '#ffffff', 
'&:hover': {
        backgroundColor: '#0d3476', 
      },	  
    }}
  >
    Add
  </Fab>
</NavLink>


      </div>
    );
  }
}

export default Productlist;
